/**
 * Constants for My Money section
 */

// Category configuration with emoji, background color, and accent color
// Colors follow Figma design (node 27500-33762): Functional colors + Branding/Primary/SP300
export const CATEGORY_CONFIG: Record<
  string,
  { emoji: string; bgColor: string; color: string }
> = {
  // Error/R400 (coral)
  FOOD_AND_DRINK: {
    emoji: "🍽️",
    bgColor: "rgba(237, 125, 84, 0.25)",
    color: "#ED7D54",
  },
  // Info/B500 (blue)
  GENERAL_MERCHANDISE: {
    emoji: "🛍️",
    bgColor: "#E5FCFF",
    color: "#2EA5FA",
  },
  // Success/G500 (green)
  RENT_AND_UTILITIES: {
    emoji: "💡",
    bgColor: "#F8FFE0",
    color: "#74B40E",
  },
  // Warning/Y500 (yellow)
  TRAVEL: {
    emoji: "✈️",
    bgColor: "#FFFACC",
    color: "#FFD900",
  },
  // Neutral N900 (grey)
  TRANSPORTATION: {
    emoji: "🚗",
    bgColor: "#F4F5F6",
    color: "#141414",
  },
  // Success/G500 (green) – Entertainment in Figma
  ENTERTAINMENT: {
    emoji: "🎬",
    bgColor: "#F8FFE0",
    color: "#74B40E",
  },
  // Branding/Primary/SP300 (green) – Personal Care in Figma
  PERSONAL_CARE: {
    emoji: "💆",
    bgColor: "rgba(91, 187, 111, 0.25)",
    color: "#5BBB6F",
  },
  // Neutral N900 (grey)
  GENERAL_SERVICES: {
    emoji: "🛠️",
    bgColor: "#F4F5F6",
    color: "#141414",
  },
  GOVERNMENT_AND_NON_PROFIT: {
    emoji: "🏛️",
    bgColor: "#F4F5F6",
    color: "#141414",
  },
  // Warning/Y500 (amber/yellow) – Home improvement in Figma
  HOME_IMPROVEMENT: {
    emoji: "🏠",
    bgColor: "#FFFACC",
    color: "#FFD900",
  },
  // Error/R700 (red)
  MEDICAL: {
    emoji: "🏥",
    bgColor: "#FDE7D1",
    color: "#A4160E",
  },
  BANK_FEES: {
    emoji: "🏦",
    bgColor: "#F4F5F6",
    color: "#141414",
  },
  TRANSFER_OUT: {
    emoji: "💸",
    bgColor: "#F4F5F6",
    color: "#141414",
  },
  // Success/G500 (green)
  TRANSFER_IN: {
    emoji: "💰",
    bgColor: "#F8FFE0",
    color: "#74B40E",
  },
  LOAN_PAYMENTS: {
    emoji: "📋",
    bgColor: "#F4F5F6",
    color: "#141414",
  },
  INCOME: {
    emoji: "💵",
    bgColor: "#F8FFE0",
    color: "#74B40E",
  },
};

// Default category config for unknown categories (Neutral N900)
export const DEFAULT_CATEGORY_CONFIG = {
  emoji: "📦",
  bgColor: "#F4F5F6",
  color: "#141414",
};

// Budget categories to display (in order)
export const BUDGET_CATEGORIES = [
  "ENTERTAINMENT",
  "FOOD_AND_DRINK",
  "GENERAL_MERCHANDISE",
  "PERSONAL_CARE",
  "TRAVEL",
  "GENERAL_SERVICES",
  "HOME_IMPROVEMENT",
  "MEDICAL",
  "TRANSPORTATION",
];

// Category display names
export const CATEGORY_DISPLAY_NAMES: Record<string, string> = {
  ENTERTAINMENT: "Entertainment",
  FOOD_AND_DRINK: "Food & Drink",
  GENERAL_MERCHANDISE: "General Merchandise",
  PERSONAL_CARE: "Personal Care",
  TRAVEL: "Travel",
  GENERAL_SERVICES: "General Services",
  HOME_IMPROVEMENT: "Home improvement",
  MEDICAL: "Medical",
  TRANSPORTATION: "Transportation",
  RENT_AND_UTILITIES: "Rent & Utilities",
  BANK_FEES: "Bank Fees",
  TRANSFER_OUT: "Transfer Out",
  TRANSFER_IN: "Transfer In",
  LOAN_PAYMENTS: "Loan Payments",
  INCOME: "Income",
  GOVERNMENT_AND_NON_PROFIT: "Government",
};
